import { useContext } from "react";
import { AUTH_JWT_MEMBER_ID } from "@config/config";
import { ApplicationContext } from "@context/ApplicationContext";

const useBypassConfig = () => {
    const { whiteLabel } = useContext(ApplicationContext);

    const isBypassActive = whiteLabel?.subscriber_group?.bypass_lets_get_started === true;
    const promptUserForEmail = whiteLabel?.subscriber_group?.prompt_user_for_email === true;
    const shouldShowDisplayName =
        isBypassActive &&
        whiteLabel?.subscriber_group?.add_display_name === true &&
        whiteLabel?.subscriber_group?.jwt_authentication_type === AUTH_JWT_MEMBER_ID;

    return {
        isBypassActive,
        promptUserForEmail,
        shouldShowDisplayName,
    };
};

export default useBypassConfig;
